import React, { useEffect, useState, useContext, useRef } from "react";
import 'react-tabs/style/react-tabs.css';
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { DynamicInput } from "../../../components/DynamicInput";
import { DynamicSelect } from "../../../components/DynamicSelect";
import { Footer } from "../../../components/Footer";
import { StldRow } from "../../../styled-components/StldRow.style";
import { useForm } from 'react-hook-form';
import api from '../../../services/api';
import { MobileContext } from "../../../contexts/MobileContext";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { getClients } from '../../../services/clientes';
import * as moment from 'moment'
import DatePicker from 'react-datepicker';
import InputMask from "react-input-mask";
import Flex from '@react-css/flex';
import { StyledTablePage } from "../../../styled-components/StyledTablePage.style";
import XLSX from 'sheetjs-style';
import Swal from "sweetalert2";
import useUser from "../../../utils/useUser";
import { IconRefresh } from "../../../svg";
import { getAreas } from '../../../services/areas';
import { Multiselect } from 'multiselect-react-dropdown';
import { getPeritos } from '../../../services/peritos';
import { ModalExportar } from "../../../components/ModalExportar";
import { StldColumn } from "../../../styled-components/StldColumn.style";

const getLista = async (formValues = null, currentPage = 0, pageSize) => {
    let list = null;

    let params = "";

    if (formValues.idTimesheet?.length > 0) {
        params += `&IdTimesheet=${formValues.idTimesheet}`;
    }

    if (formValues.Sigla?.length > 0) {
        params += `&Sigla=${formValues.Sigla}`;
    }

    if (formValues.NumeroTimesheet?.length > 0) {
        params += `&NumeroTimesheet=${formValues.NumeroTimesheet}`;
    }

    if (formValues.idCliente > 0) {
        params += `&IdCliente=${formValues.idCliente}`;
    }

    if (formValues.idPerito > 0) {
        params += `&IdPerito=${formValues.idPerito}`;
    }

    if (formValues.startDate) {
        params += `&PeriodoInicial=${moment(formValues.startDate).format('YYYY-MM-DD')}`;
    }

    if (formValues.endDate) {
        params += `&PeriodoFinal=${moment(formValues.endDate).format('YYYY-MM-DD')}`;
    }

    if (formValues.areas?.length > 0) {
        formValues.areas.forEach(area => {
            params += `&IdAreas=${area.idArea}`;
        });
    }

    try {
        const response = await api.get(`Timesheet/ListaAtividades?${params}`);
        list = response.data;
        console.log("Lista de Meritocracia", list);
        return list;
    } catch (error) {
        registrationFailure(error?.response?.data?.notification?.messageReturn)
        return list;
    }
}

const registrationFailure = (text = "Ops, ocorreu um erro!. Tente novamente em instantes.") => {
    Swal.fire({
        title: "Atenção",
        text: text,
        icon: "error",
        confirmButtonText: "OK",
    });
}

export const Meritocracia = () => {
    const [ListaData, setListaData] = useState(null);
    const [TotaisData, setTotaisData] = useState(null);
    const { register, handleSubmit, reset, getValues } = useForm();
    const [clientList, setClientList] = useState([]);
    var [cliente, setCliente] = useState(null);
    var [idCliente, setIdCliente] = useState(null);
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    var [peritosList, setPeritosList] = useState([]);
    var [peritosText, setPeritosText] = useState(null);
    var [idPeritos, setPeritosId] = useState(null);
    var [loadingData, setLoadingData] = useState(false);
    const [totalRecebimentoPercentual, setTotalRecebimentoPercentual] = useState(0);

    const formSubmit = async (data) => {
        if(!selectedAreas || selectedAreas.length === 0) {
            Swal.fire({
                title: "Atenção",
                text: "Antes de continuar, selecione as áreas que deseja consultar.",
                icon: "error",
                confirmButtonText: "OK",
            });
            return
        }

        loadTable(data);
    }

    const loadTable = async (data) => {
        setLoadingData(true);
        let formValues = {
            idTimesheet: data?.IdTimesheet,
            NumeroTimesheet: data?.NumeroTimesheet,
            Sigla: data?.Sigla,
            idCliente: idCliente,
            idPerito: idPeritos,
            startDate: startDate,
            endDate: endDate,
            areas: selectedAreas
        };

        const result = await getLista(formValues);
        setListaData(result?.data?.list);
        setTotaisData(result?.data?.totais);

        // cálculo da porcentagem
        if (result?.data?.list) {
            // Filtra apenas os itens que não são descontos
            const itensValidos = result.data.list.filter(it =>
                it.nome !== 'Total Descontos' && it.nome !== 'Desconto TS'
            );

            // Soma total de horas faturadas
            const totalHorasFaturadas = itensValidos.reduce((acc, item) => {
                const horas = parseFloat(item.totalHorasFaturadas?.replace(',', '.')) || 0;
                return acc + horas;
            }, 0);

            // Soma total de horas recebidas
            const totalHorasRecebidas = itensValidos
                .filter(item => item.statusRecebimento === "Recebido")
                .reduce((acc, item) => {
                    const horas = parseFloat(item.totalHorasFaturadas?.replace(',', '.')) || 0;
                    return acc + horas;
                }, 0);

            const perc = totalHorasFaturadas > 0
                ? ((totalHorasRecebidas / totalHorasFaturadas) * 100).toFixed(2)
                : 0;

            setTotalRecebimentoPercentual(perc);
        }
        setLoadingData(false);
    }

    const getCliente = (currentValue, value) => {

        if (value === null || value === "") {
            cliente = null;
            idCliente = null;
            setCliente(cliente);
            setIdCliente(idCliente);
        }


        var clienteResult = clientList.filter(function (o) {
            return o.idCliente == value;
        });
        cliente = clienteResult[0].cliente;
        idCliente = clienteResult[0].idCliente;
        setCliente(cliente);
        setIdCliente(idCliente);
    };

    useEffect(() => {
        const asyncFn = async () => {
            const clients = await getClients();
            if (!!clients) {
                setClientList(clients);
            }

            const peritos = await getPeritos();
            if (!!peritos) {
                const peritosFormatados = []
                peritos.map(perito => {
                    var item = {
                        "value": perito.idUsuario,
                        "id": perito.idUsuario,
                        "label": perito.nome
                    };
                    peritosFormatados.push(item);
                });
                setPeritosList(peritosFormatados);
            }

            const allAreas = await getAreas();
            if (allAreas && allAreas.length > 0) {
                if (allAreas.length > 1) {
                    // Adiciona opção "Todos" apenas se houver mais de uma área
                    const areasWithAll = [
                        { idArea: -1, description: "Selecionar Todos" },
                        ...allAreas
                    ];
                    setPreselectedAreas(areasWithAll);
                } else {
                    // Apenas uma área, não adiciona "Todos"
                    setPreselectedAreas(allAreas);
                }

                // seleciona todas as áreas (sem incluir o "Todos")
                setSelectedAreas(allAreas);
            }
        }

        asyncFn();
    }, [null, 0, 10]);

    const [startDate, setStartDate] = useState(null);
    const handleStartDateChange = (date) => {
        setStartDate(date);
    }

    const [endDate, setEndtDate] = useState(null);
    const handleEndDateChange = (date) => {
        setEndtDate(date);
    }

    const formatNumberValue = (value) => {

        if (null === value || undefined === value || '' === value) {
            return 0;
        }


        if (typeof value === 'number') {
            return value;
        }

        value = value.replace(/(\.)/g, '').replace('-', '').replace('R$', '').replace(',', '.');
        if (isNaN(value)) {
            return 0;
        }

        value = parseFloat(value);

        return value;
    }

    const autofitColumns = (json, worksheet) => {
        let objectMaxLength = [];

        json.map(jsonData => {
            Object.entries(jsonData)
                .map(([, v], idx) => {
                    let columnValue = v
                    objectMaxLength[idx] = objectMaxLength[idx] >= columnValue.length ? objectMaxLength[idx] : columnValue.length
                })
        })

        const wscols = objectMaxLength.map((w) => ({ width: w < 20 ? 20 : w }))
        worksheet["!cols"] = wscols;
    }

    const onGetPerito = (perito, value) => {
        if (value === "clear" || value === null) {
            setPeritosText(null);
            setPeritosId([]);
            return;
        }

        var porteSinistroResult = peritosList.filter(function (o) {
            return o.id == value;
        });
        console.log(porteSinistroResult)

        idPeritos = porteSinistroResult[0].id;
        peritosText = porteSinistroResult[0].label;
        setPeritosText(peritosText);
        setPeritosId(idPeritos);
    };

    const refreshData = async () => {

        const valuesForm = getValues();
        let formValues = {
            idTimesheet: valuesForm?.IdTimesheet,
            NumeroTimesheet: valuesForm?.NumeroTimesheet,
            Sigla: valuesForm?.Sigla,
            idCliente: idCliente,
            idPerito: idPeritos,
            startDate: startDate,
            endDate: endDate
        };

        loadTable(formValues);
    };

    // Multiselect
    const [selectedAreas, setSelectedAreas] = useState([]);
    const [preselectedAreas, setPreselectedAreas] = useState([]);

    const handleSelectArea = (selectedList, selectedItem) => {
        if (selectedItem.idArea === -1) {
            // Selecionou "Todos": selecionar todas as áreas (exceto o item "Todos")
            const all = preselectedAreas.filter(a => a.idArea !== -1);
            setSelectedAreas(all);
        } else {
            const filtered = selectedList.filter(a => a.idArea !== -1);
            setSelectedAreas(filtered);
        }
    };

    const handleRemoveArea = (selectedList, removedItem) => {
        if (removedItem.idArea === -1) {
            // Removeu "Todos": limpa tudo
            setSelectedAreas([]);
        } else {
            const filtered = selectedList.filter(a => a.idArea !== -1);
            setSelectedAreas(filtered);
        }
    };


    const [modalMeritocraciaExportar, setModalMeritocraciaExportar] = useState(false);
    const openModalMeritocraciaExportar = () => { setModalMeritocraciaExportar(true); }
    const closeModalMeritocraciaExportar = (currentValue, value) => { setModalMeritocraciaExportar(false); }

    const handleExportarRelatorio = async () => {
        const valuesForm = getValues();

        let formValues = {
            idTimesheet: valuesForm?.IdTimesheet,
            NumeroTimesheet: valuesForm?.NumeroTimesheet,
            Sigla: valuesForm?.Sigla,
            idCliente: idCliente,
            idPerito: idPeritos,
            segurado: valuesForm?.Segurado,
            periodoInicial: startDate,
            periodoFinal: endDate,
            idAreas: selectedAreas?.map(area => area.idArea)
        };

        try {
            const response = await api.post(`Timesheet/MeritocraciaExport`, formValues, {
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            const contentDisposition = response.headers['content-disposition'];
            let fileName = `Meritocracia_${moment().format('DDMMYYYY')}.xlsx`;

            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/);
                if (fileNameMatch && fileNameMatch.length === 2) {
                    fileName = fileNameMatch[1];
                }
            }

            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            return true;

        } catch (error) {
            console.error("Erro ao exportar", error);
            throw error;
        }
    }

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header">Meritocracia</h5>
                            <span title="Atualizar" className="cursorPointer" onClick={refreshData}><IconRefresh color={"#EE4B21"} /></span>
                        </div>
                    </div>
                    <div className="card">
                        <StyledForm onSubmit={handleSubmit(formSubmit)}>
                            <div className='form-wrapper filter-container'>
                                {/* <div className="position-relative form-group col-sm-12 col-md-12 col-lg-12 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'ID Timesheet'} name={'IdTimesheet'} register={register} />
                                </div>
                                <hr style={{ margin: "0px 9px 15px", width: "100%" }}></hr> */}
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Nº Timesheet(Ex: TS01)'} name={'NumeroTimesheet'} register={register} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Sigla'} name={'Sigla'} register={register} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2">
                                    <DynamicSelect placeholder={''} valuetext={cliente} label={'Selecione o cliente'} name={'idCliente'} options={clientList} keyValue={'idCliente'} keyLabel={'cliente'} paramMethod={getCliente} clearOption={true} />
                                </div>
                                {
                                    useUser()?.user.nivel != 3 && (
                                        <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2">
                                            <DynamicSelect placeholder={''}
                                                valuetext={peritosText}
                                                label={'Profissionais'}
                                                name={'idPeritos'}
                                                options={peritosList}
                                                keyValue={'value'}
                                                keyLabel={'label'}
                                                paramMethod={onGetPerito}
                                                clearOption={true} />
                                        </div>
                                    )
                                }
                                <div className="position-relative col-sm-6 col-md-6 col-lg-6 pt-2">
                                    <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 pl-0" style={{ float: 'left' }}>
                                        <DatePicker
                                            dateFormat="dd/MM/yyyy"
                                            locale="pt-BR"
                                            className="input-form"
                                            selected={startDate}
                                            onChange={handleStartDateChange}
                                            placeholderText={'Data de início da emissão'}
                                            customInput={<InputMask mask="99/99/9999" className="input-form py-2" style={{ width: '100%' }} />}
                                        />
                                    </div>
                                    <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 pl-0" style={{ float: 'left' }}>
                                        <DatePicker
                                            dateFormat="dd/MM/yyyy"
                                            locale="pt-BR"
                                            className="input-form"
                                            selected={endDate}
                                            onChange={handleEndDateChange}
                                            placeholderText={'Data fim da emissão'}
                                            customInput={<InputMask mask="99/99/9999" className="input-form py-2" style={{ width: '100%' }} />}
                                        />
                                    </div>
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-12 col-lg-12 p-0">
                                    <div className="position-relative form-group col-sm-12 col-md-12 col-lg-12 pl-0" style={{ float: 'left' }}>
                                        <Multiselect
                                            className="searchWrapperCustom"
                                            placeholder={'Selecione a Área'}
                                            showCheckbox="true"
                                            options={preselectedAreas} // Options to display in the dropdown
                                            selectedValues={
                                                selectedAreas.length === preselectedAreas.length - 1
                                                    ? preselectedAreas // se todas estão selecionadas, inclui "Todos"
                                                    : selectedAreas
                                            }
                                            onSelect={handleSelectArea} // Function will trigger on select event
                                            onRemove={handleRemoveArea} // Function will trigger on remove event
                                            displayValue="description" // Property name to display in the dropdown options
                                            showArrow={true}
                                        />
                                    </div>
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-9 col-lg-9 p-2">
                                    <input type="submit" className='default-button-red' value='Pesquisar' />
                                    {
                                        ListaData?.length > 0 && (<input type="button" className='default-button-red ml-3' value='Exportar' onClick={openModalMeritocraciaExportar} />)
                                    }
                                </div>
                                <div className="position-relative text-right form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <div className="bold" style={{fontSize: "15px"}}>
                                        <span>
                                            <span className="me-1 text-secondary">Total Recebido:</span>
                                            <span className="me-3">{totalRecebimentoPercentual}%</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </StyledForm>
                        <br />
                        <StldRow>
                            <Flex>
                                <StyledForm style={{ width: "100%" }}>
                                    {loadingData ? <StldRow>
                                        <div className="text-center">
                                            <div className="d-flex align-items-center">
                                                <strong style={{ color: "#EE4B21" }}>Atualizando...</strong>
                                                <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                            </div>
                                        </div>
                                    </StldRow> : ''}
                                    <StyledTablePage>
                                        {
                                            ListaData != null && ListaData?.length > 0 ? (
                                                <div className="table-scroll font-0-9x">
                                                    <table className="table table-bordered table-width table-sm">
                                                        <thead>
                                                            {
                                                                TotaisData?.totalHorasFaturadas != null ? (
                                                                    <tr className="custon-tr-total-lanc">
                                                                        <td className="text-center">Total</td>
                                                                        <td className="text-center"></td>
                                                                        <td className="text-center"><strong>{TotaisData?.totalHorasFaturadas}</strong></td>
                                                                        <td className="text-center"><strong>{TotaisData?.totalValorFaturados}</strong></td>
                                                                        <td className="text-center "></td>
                                                                        <td className="text-center "></td>
                                                                        <td className="text-center "></td>
                                                                        <td className="text-center "></td>
                                                                        <td className="text-center "></td>
                                                                        <td className="text-center "></td>
                                                                        <td className="text-center "></td>
                                                                        <td className="text-center "></td>
                                                                    </tr>

                                                                ) : null
                                                            }
                                                            <tr className="table-legend-info">
                                                                <th key="Profissional">Profissional</th>
                                                                <th key="Área">Área</th>
                                                                <th key="HF">HF</th>
                                                                <th key="Valor">Valor</th>
                                                                <th key="Código">Código</th>
                                                                <th key="Seguradora">Seguradora</th>
                                                                <th key="Sinistro">Sinistro</th>
                                                                <th key="TS | Status">TS | Status</th>
                                                                <th key="Data Emissão">Data Emissão</th>
                                                                <th key="Nº NF">Nº NF</th>
                                                                <th key="Status">Status</th>
                                                                <th key="Data Recebimento">Data Recebimento</th>
                                                                {/* <th key="Data Exportação">Data Exportação</th> */}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {ListaData?.map((atividade, index) => (
                                                                <tr key={index} className={`${atividade.nome === 'Total Descontos' ? 'total-bg' : ''}${atividade.nome === 'Desconto TS' ? ' desconto-ts ' : ''}`}>
                                                                    <td className="text-center">{atividade.nome}</td>
                                                                    <td className="text-center text-no-wrap">{atividade.nomeArea}</td>
                                                                    <td className="text-center">{atividade.totalHorasFaturadas}</td>
                                                                    <td className="text-center">{atividade.totalExecutado}</td>
                                                                    <td className="text-center">{atividade.sigla}_{atividade.numeroTimesheet}</td>
                                                                    <td className="text-center">{atividade.cliente}</td>
                                                                    <td className="text-center">{atividade.numeroSinistro}</td>
                                                                    <td className="text-center">{atividade.numeroTimesheet.replace("TS", "")} | {atividade.tipoTimesheet}</td>
                                                                    <td className="text-center">{atividade.dataEmissaoNotaFiscal == '01/01/0001' ? '-' : atividade.dataEmissaoNotaFiscal}</td>
                                                                    <td className="text-center">{atividade.numero}</td>
                                                                    <td className="text-center">{atividade.statusRecebimento}</td>
                                                                    <td className="text-center">
                                                                        { !atividade.dataRecebimento ||
                                                                            moment(atividade.dataRecebimento).format('DD/MM/YYYY') === 'Invalid date'
                                                                            ? '-'
                                                                            : moment(atividade.dataRecebimento).format('DD/MM/YYYY')
                                                                        }
                                                                    </td>                                                                    
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                ListaData?.length == 0 &&
                                                <StldColumn xs="12" sm="12" md="12">
                                                    <div className="alert alert-warning" role="alert">
                                                        Atenção! Nenhum resultado encontrado!
                                                    </div>
                                                </StldColumn>
                                            )
                                        }
                                    </StyledTablePage>
                                </StyledForm>
                            </Flex>
                        </StldRow>
                    </div>
                    
                    <ModalExportar
                        key={"ModalMeritocraciaExportar"}
                        isOpen={modalMeritocraciaExportar}
                        onRequestClose={closeModalMeritocraciaExportar}
                        setIsOpen={() => setModalMeritocraciaExportar(false)}
                        onExportar={handleExportarRelatorio}
                    ></ModalExportar>
                </StyledDefaultPage>
            </main>
        </section>
    );
};

export const MeritocraciaPage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <Meritocracia />

                </>
            )}
        </>
    );
};
